module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Learning-Success",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.5,5 L49.5,5 L49.5,5 C50.8807119,5 52,6.11928813 52,7.5 L52,8 C52,9.1045695 51.1045695,10 50,10 L50,14 L51,14 C53.7614237,14 56,16.2385763 56,19 L56,27 C56,29.7614237 53.7614237,32 51,32 L50,32 C50,36.9705627 45.9705627,41 41,41 L38,41 L38,50 L48.5,50 L48.5,50 C49.8807119,50 51,51.1192881 51,52.5 L51,52.5 C51,53.8807119 49.8807119,55 48.5,55 L22.5,55 L22.5,55 C21.1192881,55 20,53.8807119 20,52.5 C20,51.1192881 21.1192881,50 22.5,50 L32,50 L32,41 L29,41 L29,41 C24.0294373,41 20,36.9705627 20,32 L20,32 L19,32 L19,32 C16.2385763,32 14,29.7614237 14,27 L14,19 C14,16.2385763 16.2385763,14 19,14 L20,14 L20,10 C18.8954305,10 18,9.1045695 18,8 L18,7.5 L18,7.5 C18,6.11928813 19.1192881,5 20.5,5 L20.5,5 Z M19,17 L19,17 C17.8954305,17 17,17.8954305 17,19 L17,19 L17,27 C17,28.1045695 17.8954305,29 19,29 L20,29 L20,17 L19,17 Z M50,17 L50,29 L51,29 C52.1045695,29 53,28.1045695 53,27 L53,19 C53,17.8954305 52.1045695,17 51,17 L50,17 Z M35,26.5 L40.2900673,29.2811529 L39.2797543,23.3905765 L43.5595086,19.2188471 L37.6450336,18.3594235 L35,13 L32.3549664,18.3594235 L26.4404914,19.2188471 L30.7202457,23.3905765 L29.7099327,29.2811529 L35,26.5 Z",
      "id": "Combined-Shape"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7cb5a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/learning_success.vue
// module id = 637
// module chunks = 1